<template>
    <BaseDialog
        :showDialog="showDialog"
        headline="lang_GENERIC_CAPTION_EXPORT"
        :close="closeDialog"
        persistent
        maxDialogWidth="600"
        maxCardHeight="500"
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid>
                <v-row>
                    <v-col cols="4">
                        <BaseEditPageDropdown 
                                :context="context"
                                field="Type" 
                                :items="typeItems" 
                                :label="$t('lang_PUBLISHING_WORKS_CAPTION_TYPE')"
                                :selection="true"
                                :withMargin="false"
                                hideDetails
                                :clearable="false"
                                :alvqa="alvqa + '-dropdown-type'"
                            />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <BaseEditPageDropdown 
                            :context="context"
                            field="MappingId"
                            :items="exportMappingsList"
                            :label="$t('lang_GENERIC_CAPTION_ABBREVIATION')"
                            :selection="true"
                            :withMargin="false"
                            hideDetails
                            :clearable="false"
                            :alvqa="alvqa + '-dropdown-mapping-abbreviation'"
                            :error-messages="mappingError"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <BaseCheckbox 
                            :context="context + 'TracksReleases'"
                            :label="$t('lang_CONTRACTS_LABEL_EXPORT_DIALOG_INCLUDE_TRACKS_RELEASES')" 
                            hideDetails
                            class="mt-0"
                            :alvqa="alvqa + '-include-tracks-releases-checkbox'"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>
        <template v-slot:dialogActions>
            <v-container fluid>
                <v-row>
                    <v-col cols="12" class="text-right">
                        <BaseButton 
                            label="lang_BUTTON_START"
                            @click="exportMapping"
                            :disabled="disabled"
                            :alvqa="alvqa+'-button-start'"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseCheckbox from '@/components/_base/BaseCheckbox'

export default {
    name: "ContractsLabelExportDialog",
    components: {
        BaseDialog,
        BaseButton,
        BaseEditPageDropdown,
        BaseCheckbox
    },
    data() {
        return {
            alvqa: 'contracts-label-list-dialog-export',
            context: 'ContractsLabelExport',
            mappingError: ''
        }
    },
    computed: {
        showDialog: {
            get()       { return this.$store.getters.getShowContractsLabelExportDialog },
            set(show)   { this.$store.commit('setShowContractsLabelExportDialog', show) }
        },
        isAllSelected: {
            get()       { return this.$store.getters.getContractsLabelExportAll },
            set(value)  { this.$store.commit('setContractsLabelExportAll', value) }
        },
        disabled() {
            if(!this.$store.getters.getContractsLabelExportDetailsMappingId) return true

            if(this.$store.getters.getIsLoading) return true
            
            return false
        },
        typeItems() {
            return [
                {text: this.$t('lang_ACCOUNT_MAPPINGS'), value: 'mappings', alvqa: this.alvqa + '-dropdown-type-mappings'}
            ]
        },
        getType() {
            return this.$store.getters.getContractsLabelExportDetailsType;
        },
        exportMappingsList() {
            let mappingsList = this.$store.getters.getMappings
            let retArr = []
            mappingsList.forEach((v) => {
                if (v.direction !== 'export') return;
                 
                retArr.push({
                    value: v.alvId,
                    text: v.abbreviation,
                    alvqa: this.alvqa + `-export-mapping-${v.alvId}`
                })
            })
            return retArr
        },
    },
    methods: {
        closeDialog() {
            this.showDialog = false
            this.isAllSelected = false
            this.$store.commit('setContractsLabelExportDetailsMappingId', null)
            this.$store.commit('setContractsLabelExportTracksReleasesCheckbox', false)
        },
        exportMapping() {
            if (this.$store.getters.getSelectedLabelContracts.length === 0) {
                this.isAllSelected = true;
            }
            this.$store.dispatch('exportContractsLabelMapping')
            this.closeDialog()
        },
        getMappings() {
            this.$store.commit('setSelectedMappingsDomainsFilter', 'contracts_label')
            this.$store.dispatch('fetchMappingsByDomain')
        },
    },
    created() {
        this.getMappings();
    }
}
</script>